// Idiomas del sitio. Para AGREGAR uno: sumarlo a LOCALES y a LOCALE_META —
// TypeScript marca entonces cada archivo *.i18n.ts al que le falta ese idioma
// (ver defineMessages). Para QUITAR uno: sacarlo de ambos y borrar su bloque
// en cada *.i18n.ts (también los marca el compilador).
export const LOCALES = ["es", "en"] as const;
export type Locale = (typeof LOCALES)[number];

// Fuente de verdad de los textos: el resto de los idiomas se valida contra él.
export const DEFAULT_LOCALE = "es" satisfies Locale;

// Solo la lee proxy.ts para redirigir URLs sin prefijo al idioma elegido —
// nunca el render (leer cookies vuelve dinámica la página y gasta functions).
export const LOCALE_COOKIE = "cv-locale";

export const LOCALE_META: Record<
  Locale,
  { htmlLang: string; ogLocale: string; intl: string; label: string; short: string }
> = {
  es: { htmlLang: "es", ogLocale: "es_CL", intl: "es-CL", label: "Español", short: "ES" },
  en: { htmlLang: "en", ogLocale: "en_US", intl: "en-US", label: "English", short: "EN" },
};

export function isLocale(value: string | undefined | null): value is Locale {
  return !!value && (LOCALES as readonly string[]).includes(value);
}
